module.exports = __webpack_public_path__ + "static/media/wpexplorer.459fe605.svg";